import { Component } from '@angular/core';
import { UntypedFormGroup, ReactiveFormsModule } from '@angular/forms';
import { ExportInterfaceConfigurationFinanceDataSelectionType, ExportInterfaceConfigurationFinanceSchedule } from 'src/app/base/models/models.swagger.generated';
import { ConfigurationFormCoordinatorService } from '../configuration-form-coordinator.service';
import { TranslateModule } from '@ngx-translate/core';
import { YesNoGroupButtonComponent } from '../../../../../base/shared/yes-no-group-button/yes-no-group-button.component';
import { AppErrorMessagesComponent } from '../../../../../base/error-messages/app-error-messages.component';
import { EnumDropDownListComponent } from '../../../../../base/shared/enum-drop-down-list/enum-drop-down-list.component';

@Component({
    selector: 'app-configuration-form-finance',
    templateUrl: './configuration-form-finance.component.html',
    styleUrls: ['./configuration-form-finance.component.scss'],
    imports: [ReactiveFormsModule, EnumDropDownListComponent, AppErrorMessagesComponent, YesNoGroupButtonComponent, TranslateModule]
})
export class ConfigurationFormFinanceComponent {

  public FinanceDataSelectionType = ExportInterfaceConfigurationFinanceDataSelectionType;
  public Schedule = ExportInterfaceConfigurationFinanceSchedule;
  
  public get configurationFormFinance(): UntypedFormGroup {
    return this.configurationFormService.configurationFormFinance;
  }

  constructor(private configurationFormService: ConfigurationFormCoordinatorService) { }
}
